/* tslint:disable */
/* eslint-disable */
/**
 * ROC API
 * Referral Outbound Center (ROC) API for managing outbound referrals between post-acute care facilities.  All endpoints require a valid JWT. Organization and user identity are derived from the token — callers never pass these in query params or request bodies. 
 *
 * The version of the OpenAPI document: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OutboundReferralItem } from './OutboundReferralItem';
import {
    OutboundReferralItemFromJSON,
    OutboundReferralItemFromJSONTyped,
    OutboundReferralItemToJSON,
    OutboundReferralItemToJSONTyped,
} from './OutboundReferralItem';

/**
 * 
 * @export
 * @interface ListOutboundReferrals200Response
 */
export interface ListOutboundReferrals200Response {
    /**
     * 
     */
    items: Array<OutboundReferralItem>;
    /**
     * Opaque cursor for fetching the next page. Null when no more results.
     */
    cursor: string;
}

/**
 * Check if a given object implements the ListOutboundReferrals200Response interface.
 */
export function instanceOfListOutboundReferrals200Response(value: object): value is ListOutboundReferrals200Response {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('cursor' in value) || value['cursor'] === undefined) return false;
    return true;
}

export function ListOutboundReferrals200ResponseFromJSON(json: any): ListOutboundReferrals200Response {
    return ListOutboundReferrals200ResponseFromJSONTyped(json, false);
}

export function ListOutboundReferrals200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListOutboundReferrals200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(OutboundReferralItemFromJSON)),
        'cursor': json['cursor'],
    };
}

export function ListOutboundReferrals200ResponseToJSON(json: any): ListOutboundReferrals200Response {
    return ListOutboundReferrals200ResponseToJSONTyped(json, false);
}

export function ListOutboundReferrals200ResponseToJSONTyped(value?: ListOutboundReferrals200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(OutboundReferralItemToJSON)),
        'cursor': value['cursor'],
    };
}

